/**
 * Sports categories for selection news
 */
export type SportCategory =
  | 'cricket'
  | 'football'
  | 'basketball'
  | 'hockey'
  | 'tennis'
  | 'badminton'
  | 'athletics'
  | 'swimming'
  | 'volleyball'
  | 'kabaddi'
  | 'wrestling'
  | 'boxing'
  | 'other';

/**
 * Selection level for national/state/district selections
 */
export type SelectionLevel = 'national' | 'state' | 'district' | 'zonal' | 'university';

/**
 * Priority levels
 */
export type NewsPriority = 'low' | 'normal' | 'high' | 'urgent';

/**
 * Gender eligibility
 */
export type GenderEligibility = 'male' | 'female' | 'both';

/**
 * News - Selection news for athletes about national/state/district selection trials
 * Stored in Supabase public.news table
 * Displayed to ALL users publicly
 */
export interface News {
  id: string;
  title: string;
  content: string;
  summary: string;
  coverImageUrl?: string;
  sport: SportCategory;
  selectionLevel: SelectionLevel;
  location: string;
  selectionDate?: string;
  endDate?: string;
  registrationDeadline?: string;
  eligibilityCriteria?: string;
  registrationUrl?: string;
  contactInfo?: string;
  organizingBody?: string;
  ageGroup?: string;
  gender: GenderEligibility;
  maxParticipants?: number;
  winner?: string;
  authorId?: string;
  authorName: string;
  isActive: boolean;
  isPinned: boolean;
  views: number;
  priority: NewsPriority;
  createdAt: string;
  updatedAt: string;
}

/**
 * Data structure for creating/updating news
 */
export interface CreateNewsData {
  title: string;
  content: string;
  summary: string;
  coverImageUrl?: string;
  sport: SportCategory;
  selectionLevel: SelectionLevel;
  location: string;
  selectionDate?: string;
  endDate?: string;
  registrationDeadline?: string;
  eligibilityCriteria?: string;
  registrationUrl?: string;
  contactInfo?: string;
  organizingBody?: string;
  ageGroup?: string;
  gender?: GenderEligibility;
  maxParticipants?: number;
  winner?: string;
  isPinned?: boolean;
  priority?: NewsPriority;
}

/**
 * Stats for news dashboard
 */
export interface NewsStats {
  total: number;
  active: number;
  pinned: number;
  upcomingSelections: number;
}

/**
 * Sport options for dropdown
 */
export const SPORT_OPTIONS: { value: SportCategory; label: string }[] = [
  { value: 'cricket', label: 'Cricket' },
  { value: 'football', label: 'Football' },
  { value: 'basketball', label: 'Basketball' },
  { value: 'hockey', label: 'Hockey' },
  { value: 'tennis', label: 'Tennis' },
  { value: 'badminton', label: 'Badminton' },
  { value: 'athletics', label: 'Athletics' },
  { value: 'swimming', label: 'Swimming' },
  { value: 'volleyball', label: 'Volleyball' },
  { value: 'kabaddi', label: 'Kabaddi' },
  { value: 'wrestling', label: 'Wrestling' },
  { value: 'boxing', label: 'Boxing' },
  { value: 'other', label: 'Other' },
];

/**
 * Selection level options for dropdown
 */
export const SELECTION_LEVEL_OPTIONS: { value: SelectionLevel; label: string }[] = [
  { value: 'national', label: 'National' },
  { value: 'state', label: 'State' },
  { value: 'district', label: 'District' },
  { value: 'zonal', label: 'Zonal' },
  { value: 'university', label: 'University' },
];

/**
 * Priority options for dropdown
 */
export const PRIORITY_OPTIONS: { value: NewsPriority; label: string }[] = [
  { value: 'low', label: 'Low' },
  { value: 'normal', label: 'Normal' },
  { value: 'high', label: 'High' },
  { value: 'urgent', label: 'Urgent' },
];
